/*
 * Shared heading and chrome destination for fallback route pages.
 * The application shell docks navigation in this declared action outlet at expanded widths.
 * Example: <PageChromeHeader heading={<h1>Page not found</h1>}/>
 */

export function PageChromeHeader({ heading }) {
  return (
    <div class="page-chrome-header">
      {heading}
      <div class="page-chrome-actions" data-page-chrome-actions/>
    </div>
  );
}
